import React from 'react';

import MAUSAnalytics from 'components/maus';
import TotalStaffUsers from 'pages/dashboard/containers/Analytics/components/totalStaffusers';
import TotalLearners from 'pages/dashboard/containers/Analytics/components/totalLearners';

const moment = require('moment');

const QuickStats = (props) => {
  return (
    <div className="quick-stats">
      <h4>Stats for {moment().format('MMM, YYYY')}</h4>
      <MAUSAnalytics title="Monthly Active Learners" />
      <TotalLearners />
      <TotalStaffUsers />
    </div>
  );
};

export default QuickStats;
